import React, { useEffect, useState } from 'react'
import { set, useFieldArray, useWatch } from 'react-hook-form'
import InputController from '../../Global/InputController'
import QuestionOptionsForm from './QuestionOptionsForm'
import { inputOptions } from '../helpers/inputQuestions'
import SurveyResponseForm from './SurveyResponseForm'
import RaitingForm from './RaitingForm'

const QuestionsAdd = ({
  surveyId,
  emptyText = 'No hay elementos',
  prefix = 'prefix',
  control = 'control',
  inputs = [],
  optionsQuestions,
  idsToDeleteQuestions,
  setIdsToDeleteQuestions,
  idsToDeleteOptions,
  setIdsToDeleteOptions,
  setValue,
  getValues,
  questionsEdit,
  reset,
  show,
}) => {
  const [valueSelect, setValueSelect] = useState([])
  const { fields, append, remove } = useFieldArray({
    control,
    name: prefix,
  })

  useEffect(() => {
    if (questionsEdit.length > 0) {
      questionsEdit.map((question, idx) => {
        // console.log('question', question)
        setValueSelect((prev) => {
          return {
            ...prev,
            [question.id]: question.key_type_question,
          }
        })

        // setValue(`${prefix}[${idx}].key_type_question`, question.key_type_question)
      })
    }
  }, [questionsEdit])

  const handleChoosen = (e, name, question, fieldIdx, prefix) => {
    console.log('e', e)
    setValueSelect((prev) => {
      return {
        ...prev,
        [question.id]: e.key,
      }
    })

    setValue(`${prefix}[${fieldIdx}].key_type_question`, e.key)

    // DELETE OPTIONS
    // if (e.label !== 'multi-choice') {
    //   setValue(control, `${name}.options`, [])
    // }

    //DELETE VALUE
    // if (e.label !== 'text') {
    //   set(
    //     control,
    //     `${prefix}[${fieldIdx}].value`,
    //     ''
    //   )
    // }
  }

  const handleRemove = (question, idx) => {
    setValueSelect((prev) => {
      const newValues = { ...prev }
      delete newValues[question.id]
      return newValues
    })

    const typeId = typeof question.id

    if (surveyId && typeId === 'number') {
      remove(idx)
      setIdsToDeleteQuestions([...idsToDeleteQuestions, question.id])
    } else {
      remove(idx)
    }
  }

  return (
    <>
      {!show && (
        <div className="mb-5 col-12">
          <button
            className="btn btn-migrates"
            type="button"
            onClick={() => append({})}
          >
            <i className="fas fa-plus"></i>
            &nbsp;Agregar pregunta
          </button>
        </div>
      )}

      {fields.length === 0 ? (
        <div className="col-12">
          <p>{emptyText || 'No hay preguntas disponibles.'}</p>
        </div>
      ) : (
        fields.map((question, fieldIdx) => (
          <div
            key={`${question.id}-${fieldIdx}`}
            className="col-12"
            style={{
              border: '1px solid #ccc',
              padding: '10px',
              marginBottom: '20px',
              borderRadius: '5px',
            }}
          >
            <div className={show ? 'hide' : ''}>
              <div className="col-12">
                <span
                  style={{ cursor: 'pointer', float: 'right' }}
                  className="btn btn-sm btn-outline-danger fas fa-trash-alt"
                  title="Eliminar"
                  onClick={() => handleRemove(question, fieldIdx)}
                />
                <h4>{`Pregunta ${fieldIdx + 1}`}</h4>
              </div>
            </div>
            <div className="row">
              {inputs.map((input, inputIdx) => (
                <div
                  key={`${question.id}-${input.name}-${inputIdx}`}
                  className={`${
                    input.type === 'hidden'
                      ? 'hidden'
                      : (show && input.name === 'type_question_id') ||
                        (show && input.name === 'is_required')
                      ? 'hide'
                      : `mb-4 col-md-12 col-lg-${show ? 12 : input.colSize}`
                  }`}
                >
                  <InputController
                    label={input.label}
                    name={`${prefix}[${fieldIdx}].${input.name}`}
                    control={control}
                    placeholder={input.placeholder}
                    inputType={input.type}
                    type={input.type}
                    options={input.type === 'choosen' ? optionsQuestions : []}
                    changeAction={
                      input.type === 'choosen'
                        ? (e) =>
                            handleChoosen(
                              e,
                              `${prefix}[${fieldIdx}].options`,
                              question,
                              fieldIdx,
                              prefix
                            )
                        : () => {}
                    }
                    disabled={show}
                  />
                </div>
              ))}
            </div>
            {((!show && valueSelect[question.id] === 'multi-choice') ||
              valueSelect[question.id] === 'choosen') && (
              <>
                <hr />
                <QuestionOptionsForm
                  parentIdx={fieldIdx}
                  prefix={`${prefix}[${fieldIdx}].options`}
                  control={control}
                  idsToDeleteOptions={idsToDeleteOptions}
                  setIdsToDeleteOptions={setIdsToDeleteOptions}
                  inputs={inputOptions}
                  surveyId={surveyId}
                  questionId={question.id}
                  setValue={setValue}
                  getValues={getValues}
                />
              </>
            )}

            {!show && valueSelect[question.id] === 'raiting' && (
              <>
                {/* <hr /> */}
                <RaitingForm
                  control={control}
                  prefix={`${prefix}[${fieldIdx}].options`}
                  prefixQuestion={`${prefix}[${fieldIdx}]`}
                  questionId={question.id}
                  setValue={setValue}
                  show={show}
                  getValues={getValues}
                  editRadio={question.value}
                  // radioLength={Array.from({ length: 5 })}
                />
              </>
            )}

            {show && (
              <>
                <hr />
                <SurveyResponseForm
                  questionId={question.id}
                  optionsForResponse={question.options}
                  responses={question.responses}
                  questionValues={question}
                  typeQuestion={question.key_type_question}
                  control={control}
                  prefix={`${prefix}[${fieldIdx}].responses`}
                  setValue={setValue}
                />
              </>
            )}
          </div>
        ))
      )}
    </>
  )
}

export default QuestionsAdd
